import { render, staticRenderFns } from "./FieldDropdown.vue?vue&type=template&id=189c7c86&"
import script from "./FieldDropdown.vue?vue&type=script&lang=js&"
export * from "./FieldDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FieldDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports